module.exports = __webpack_public_path__ + "static/media/Graphic9.30ae1a44.png";